import ks from "../ReUsableTS/kalmstromShared4";


export class kNotification{
    public static NotificationContainer:HTMLDivElement | null = null;
    public static MobileStyle:boolean = false;
    private static _SetNewElemProps = (newElem:HTMLDivElement, IsWarning:boolean): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const StyleObj:CSSStyleDeclaration = newElem.style;
            StyleObj.transition = ".3s ease";
            StyleObj.position = "relative";

            StyleObj.pointerEvents = "auto";
            StyleObj.overflow = "hidden";
            StyleObj.margin = "0 0 6px";

            StyleObj.padding = "30px";
            StyleObj.width = "300px";
            StyleObj.borderRadius = "10px 10px 10px 10px";

            StyleObj.boxShadow = "0 0 12px $grey";
            StyleObj.color = "white";
            StyleObj.opacity = "0.9";

            StyleObj.filter = "alpha(opacity=90);";
            StyleObj.backgroundPosition = "15px center";
            StyleObj.backgroundRepeat = "no-repeat";
            StyleObj.boxShadow = "4px 4px 22px 1px rgba(0,0,0,0.31)";

            StyleObj.userSelect = "none";
            StyleObj.backgroundColor = IsWarning ? "#C62828" : "green";
            StyleObj.padding = "15px 15px 15px 50px";
            StyleObj.backgroundSize = "20px 20px";
            StyleObj.backgroundImage = IsWarning
                ? "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z'/%3E%3Cline x1='12' y1='9' x2='12' y2='13'/%3E%3Cline x1='12' y1='17' x2='12.01' y2='17'/%3E%3C/svg%3E\")"
                : "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M22 11.08V12a10 10 0 11-5.93-9.14'/%3E%3Cpolyline points='22 4 12 14.01 9 11.01'/%3E%3C/svg%3E\")";

        } catch (e) { ks.kGlobalErrorHandler(e, "kNotification._SetNewElemProps"); }
    }   
    private static _ContainerStyles = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(kNotification.NotificationContainer){
                const StyleObj:CSSStyleDeclaration = kNotification.NotificationContainer.style;
                if(kNotification.MobileStyle=== false){
                    StyleObj.fontSize = "14px";
                }else{
                    StyleObj.fontSize = "28px";
                    StyleObj.paddingTop = "200px";
                    StyleObj.left = "calc(100% - 500px)";
                }
                StyleObj.boxSizing = "border-box";
                StyleObj.position = "fixed";   
                StyleObj.zIndex= "999999";
                StyleObj.top ="12px";
                StyleObj.right ="12px";
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kNotification._ContainerStyles"); }    
    }    
    public static ShowNew = (NewText:string, IsWarning?:boolean): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(kNotification.NotificationContainer === null){
                kNotification.NotificationContainer = document.createElement('div');
                kNotification._ContainerStyles();
                document.body.appendChild(kNotification.NotificationContainer);
            }

            const notificationEl:HTMLDivElement = document.createElement('div');
            kNotification._SetNewElemProps(notificationEl, IsWarning === true);

            const NotifcationPara:HTMLParagraphElement = document.createElement('p');
            NotifcationPara.innerText = NewText;
            NotifcationPara.style.margin = "0";
            NotifcationPara.style.textAlign= "left";
            NotifcationPara.style.textOverflow= "break-word";

            notificationEl.appendChild(NotifcationPara);

            (kNotification.NotificationContainer as any).prepend(notificationEl);
            window.setTimeout(kNotification.RemoveLatestNotification, 3000);
        } catch (e) { ks.kGlobalErrorHandler(e, "kNotification.ShowNew"); }
    }
    public static RemoveLatestNotification = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            //if(1===1){return}
            if(kNotification.NotificationContainer){
                const LatestNotification:HTMLDivElement = kNotification.NotificationContainer.firstChild as HTMLDivElement;
                if(LatestNotification){
                    LatestNotification.remove();
                    if(kNotification.NotificationContainer.children.length === 0){
                        kNotification.NotificationContainer.remove();
                        kNotification.NotificationContainer = null;
                    }
                }
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kNotification.RemoveLatestNotification"); }    
    }
    public static RemoveAllNotifications = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(kNotification.NotificationContainer){
                kNotification.NotificationContainer.innerHTML = "";
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kNotification.RemoveAllNotifications"); }    
    }
}